module.exports = __webpack_public_path__ + "static/media/sarva_logo.1566f2f7.png";